import { wizardFlows } from '@/modules/wizard/flows/wizard-flows'
import type { WizardFlowName } from '@/modules/wizard/types/WizardFlowName'

export const isWizardFlowName = (name: string): name is WizardFlowName =>
  Object.prototype.hasOwnProperty.call(wizardFlows, name)
